import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  siteId: "" as any,
  userToManage: {} as any,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    // Previous setSiteId({ siteId })
    setSiteId: (state, action: PayloadAction<{ siteId: any }>) => {
      state.siteId = action.payload.siteId;
    },
    // Previous setUserToManage({ userToManage })
    setUserToManage: (state, action: PayloadAction<{ userToManage: any }>) => {
      state.userToManage = action.payload.userToManage;
    },
    // Previous setResetUser() reset the whole state to initialState.
    setResetUser: () => {
      return { ...initialState };
    },
  },
});

export const { setSiteId, setUserToManage, setResetUser } = adminSlice.actions;

export default adminSlice.reducer;
